<div class="row">
  <plugin-edit
    [processing]="processing"
    [plugin]="plugin"
    (toggleSavePlugin)="savePlugin($event)"
    (toggleCancel)="cancel()"
  ></plugin-edit>
</div>
